import React, { useEffect } from 'react';
import UINCDLetterHead from './UINCDLetterHead';
import DefaultLetterHead from './DefaultLetterHead';
import { useConfig } from '../../DataStore/ConfigContext';
import SloganLetterHead from './SloganLetterHead';
const LetterHead =()=>{

    const {company, preferences, getPreferences, getCompanyProfile} = useConfig();
    
        // Fetch trial balance data whenever the level changes
        useEffect(() => {
            getCompanyProfile();
            getPreferences();
        }, []);

        if(!company || !preferences){
            return <div></div>
        }
         
        const HeaderOptions=()=>{

            if(preferences.show_letter_header && preferences.show_letter_header.preference_value==="NO"){
                return <div></div>
            }
            
            switch(preferences.letter_head_format.preference_value){

                case "UINCD":
                    return <UINCDLetterHead company={company} />
                case "SLOGAN":
                    return <SloganLetterHead company={company} />
                default:
                    return <DefaultLetterHead company={company} />

            }
        }


        return (
            <div>{HeaderOptions()}</div>
        );
    }


export default LetterHead;